import { CircularProgress } from '@material-ui/core';
import './wipDashStyle.scss';

export const WipScreenLoader = () => {
    return (
        <div className="wip-dash-loader">
            <span>
                <div>Please Wait while Fetching Data..</div>
                <CircularProgress />
            </span>
        </div>
    );
};
export const WipNoRecord = () => {
    return (
        <div className="wip-dash-loader">
            <div className="no-record">No Record Found</div>
        </div>
    );
};
